module.exports = __webpack_public_path__ + "img/artisan.60370709.jpg";